import { useState } from "react";
import "./Home.css"
import Form from "./components/form-with-multiple-components/Form";
import Header from "./Dashboards/Header";

const Home = () => {
  return (
    <>
    <Form />
    </>
  );
}


export default Home;

